import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'Components';
import './Tabs.css';

const Tabs = ({
  tabs,
  index,
  className,
  onClick,
  labels,
  ...rest
}) => (
  <div className={`tabs ${className}`}>
    { tabs.map((tab, i) => (
      <Tab
        {...rest}
        active={i === index}
        key={tab}
        onClick={() => onClick(i)}
      >
        {labels !== undefined ? labels[i] : tab}
      </Tab>
    ))}
  </div>
);

Tabs.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  index: PropTypes.number,
  tabs: PropTypes.arrayOf(PropTypes.string),
  labels: PropTypes.arrayOf(PropTypes.string),
};

Tabs.defaultProps = {
  className: 'tabs__button',
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.jsx